import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from '../../../hooks/useTranslation';
import {
  toCurrencyDisplayFormat,
  toDateStringFullMonthName,
} from '../../../util/format';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    money: {
      fontWeight: 'bold',
      minWidth: '100px',
    },
    boldtext: {
      fontWeight: 'bold',
    },
    paymentDisplay: {
      margin: theme.spacing(0, 1, 0, 2),
    },
    labelText: {
      marginRight: theme.spacing(1),
      fontFamily: 'Untitled-Sans'
    },
    contentText: {
      margin: theme.spacing(2, 2, 2, 2),
    },
    noBillText: {
      marginBottom: theme.spacing(2),
    },
  }),
);
export interface ViewRecentPaymentsProps {
  lastPaymentsDetails?: any | null | undefined;
}

const ViewRecentPayments = ({
  lastPaymentsDetails,
}: ViewRecentPaymentsProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Grid
        direction="row"
        spacing={2}
        container
        className={classes.paymentDisplay}
      >
        {lastPaymentsDetails &&
          lastPaymentsDetails.length > 0 &&
          lastPaymentsDetails.map((paymentHistory: any) => (
            <Grid
              item
              data-testid="recent-payment-details"
              className={classes.contentText}
            >
              <Grid direction="column" container>
                <Grid item>
                  <Typography variant={'h4'} className={classes.money}>
                    $
                    {toCurrencyDisplayFormat(
                      paymentHistory?.amountPaid || 0,
                      true,
                      'CR',
                    )}
                  </Typography>
                  {paymentHistory.type === 'PendingPayment' && (
                    <Typography
                      variant={'h6'}
                      className={classes.boldtext}
                      data-testid="pending-payment-text"
                    >
                      {t('RECENT_PAYMENT_PENDING_PAYMENT_LABLE')}
                    </Typography>
                  )}
                </Grid>
                <Grid item>
                  <Grid container direction="row">
                    {paymentHistory.type === 'PendingPayment' ? (
                      <Typography variant={'h6'} className={classes.labelText}>
                        {t('RECENT_PAYMENT_SUBMITTED_LABLE')}
                      </Typography>
                    ) : (
                      <Typography variant={'h6'} className={classes.labelText}>
                        {t('RECENT_PAYMENT_PAIDON_LABLE')}
                      </Typography>
                    )}
                    <Typography variant={'h6'} className={classes.boldtext}>
                      {toDateStringFullMonthName(paymentHistory?.date)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
      </Grid>

      {lastPaymentsDetails && !lastPaymentsDetails.length && (
        <Grid
          direction="row"
          container
          className={classes.paymentDisplay}
          justify="center"
          data-testid="no-payment-content"
        >
          <Grid item className={classes.noBillText}>
            <Typography className={classes.boldtext} variant={'h4'}>
              {t('NO_RECENT_PAYMENT')}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ViewRecentPayments;
